export function parseDate(str) {
  const [d, m, y] = str.split('.').map(Number);
  return new Date(y, m - 1, d);
}

export function combinedOdds(matches) {
  if (!matches || matches.length === 0) return null;
  return Number(matches.reduce((acc, m) => acc * Number(m.odd || 1), 1).toFixed(2));
}

export function entryResult(entry) {
  if (!entry.matches || entry.matches.length === 0) return 'NONE';
  if (entry.matches.some(m => m.result === 'PENDING')) return 'PENDING';
  return entry.matches.every(m => m.result === 'WIN') ? 'WIN' : 'LOST';
}

export function monthKey(dateStr) {
  const [, m, y] = dateStr.split('.');
  return `${y}-${m}`;
}

export function monthLabel(key) {
  const [y, m] = key.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleString('en-GB', { month: 'long', year: 'numeric' });
}

export function summarize(entries) {
  const played = entries.filter(e => ['WIN', 'LOST'].includes(entryResult(e)));
  const won = played.filter(e => entryResult(e) === 'WIN').length;
  const odds = played.map(e => combinedOdds(e.matches));
  const avg = odds.length ? (odds.reduce((a, b) => a + b, 0) / odds.length).toFixed(2) : '—';
  return {
    released: played.length,
    won,
    lost: played.length - won,
    winRate: played.length ? Math.round((won / played.length) * 100) : 0,
    avgOdds: avg
  };
}

export function recentForm(entries, n = 10) {
  return entries.filter(e => ['WIN', 'LOST'].includes(entryResult(e))).slice(0, n).map(entryResult);
}

export function formatDate(str) {
  return parseDate(str).toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' });
}

export function cheapestPlan(tipster) {
  return [...tipster.plans].sort((a, b) => a.price - b.price)[0];
}

export function popularPlan(tipster) {
  return tipster.plans.find(p => p.popular) || tipster.plans[tipster.plans.length - 1];
}
